import { WidgetsCargoIdsMain } from '@/widgets/cargo-ids';

export const PagesCargoIdsMain = () => <WidgetsCargoIdsMain />;
